import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "./motionUtils";
import { resume } from "../data/resume";

export const Projects = () => {
  return (
    <>
      {resume.projects.map((project, index) => {
        return (
          <div
            key={index}
            className="w-full flex flex-col space-y-1 font-poppins font-thin text-sm sm:text-sm"
          >
            <motion.div
              variants={fadeIn("right", "tween", 0, 1.5)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.05 }}
              className="w-full"
            >
              <div className="flex flex-col sm:flex-row font-lora font-bold">
                <h1 className="text-sm md:text-lg lg:text-base">
                  <span className="font-bold">{project.company_name}</span> -{" "}
                  <span>{project.company_location}</span>
                </h1>
                <h1 className="text-text-sm md:text-lg lg:text-base">
                  <i>{`—${project.position}`}</i>
                </h1>
              </div>
              <p className="uppercase text-xs sm:text-[0.7rem] font-semibold">
                {`${project.start_date} - ${project.end_date}`}
              </p>
              <p className="text-sm">{project.company_description}</p>
              {project.responsibilities.length >= 1 ? (
                <p className="text-sm">
                  {`My key
              ${
                project.end_date === "PRESENT"
                  ? "responsibilities"
                  : "accomplishments"
              }
              are as follows:`}
                </p>
              ) : (
                ""
              )}

              <div className="w-[95%] flex flex-col items-start justify-start pl-3 sm:pl-6 text-sm">
                {project.responsibilities.map((responsibility, index) => {
                  return <li key={index}>{responsibility}</li>;
                })}
              </div>
              {project.app_url.length > 2 ? (
                <a
                  href={project.app_url}
                  target={"_blank"}
                  rel="noreferrer"
                  className="text-sm"
                >
                  App Url:{" "}
                  <span className="text-amber-500">{project.app_url}</span>
                </a>
              ) : (
                ""
              )}
              <br />
              <br />
            </motion.div>
          </div>
        );
      })}
    </>
  );
};
